/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of withdrawing a team from tournament
 * @export
 * @interface TeamWithdrawResponse
 */
export interface TeamWithdrawResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TeamWithdrawResponse
     */
    success: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamWithdrawResponse
     */
    refundIssued: boolean;
    /**
     * Refund amount in cents (0 if no refund)
     * @type {number}
     * @memberof TeamWithdrawResponse
     */
    refundAmount: number;
    /**
     * Percentage of entry fee refunded
     * @type {number}
     * @memberof TeamWithdrawResponse
     */
    refundPercentage: number;
}

/**
 * Check if a given object implements the TeamWithdrawResponse interface.
 */
export function instanceOfTeamWithdrawResponse(value: object): value is TeamWithdrawResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('refundIssued' in value) || value['refundIssued'] === undefined) return false;
    if (!('refundAmount' in value) || value['refundAmount'] === undefined) return false;
    if (!('refundPercentage' in value) || value['refundPercentage'] === undefined) return false;
    return true;
}

export function TeamWithdrawResponseFromJSON(json: any): TeamWithdrawResponse {
    return TeamWithdrawResponseFromJSONTyped(json, false);
}

export function TeamWithdrawResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamWithdrawResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'refundIssued': json['refundIssued'],
        'refundAmount': json['refundAmount'],
        'refundPercentage': json['refundPercentage'],
    };
}

export function TeamWithdrawResponseToJSON(json: any): TeamWithdrawResponse {
    return TeamWithdrawResponseToJSONTyped(json, false);
}

export function TeamWithdrawResponseToJSONTyped(value?: TeamWithdrawResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'refundIssued': value['refundIssued'],
        'refundAmount': value['refundAmount'],
        'refundPercentage': value['refundPercentage'],
    };
}

